export const canCopyNodeId = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canCopyNodeId(node)
        )
    }
}

export const copyNodeId = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.actions.copyNodeId(nodes)
        )
    }
}
